import React from "react";
import { IconProps } from "../../types/component";
import useChakraColor from "../../hooks/useChakraColor";

export const Baby: React.FC<IconProps> = ({ size = 16, color = "#808080" }) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6833 0C17 0.116667 17.7717 0.566667 18.24 1.08667C18.8117 1.72167 19.1667 2.725 19.1667 4.13833C19.1669 4.58055 19.0498 5.01492 18.8273 5.39712C18.6049 5.77931 18.285 6.09566 17.9004 6.3139C17.5158 6.53213 17.0802 6.64444 16.638 6.63936C16.1958 6.63429 15.7628 6.51201 15.3833 6.285L15.1667 6.13833C14.9916 6.00701 14.7923 5.91146 14.5803 5.85714C14.3683 5.80282 14.1476 5.7908 13.931 5.82175C13.7143 5.8527 13.5058 5.92603 13.3175 6.03754C13.1292 6.14906 12.9647 6.29657 12.8333 6.47167C12.702 6.64676 12.6065 6.84601 12.5521 7.05803C12.4978 7.27005 12.4858 7.4907 12.5168 7.70737C12.5793 8.14495 12.813 8.53978 13.1667 8.805C14.0333 9.45499 15.0639 9.85081 16.1428 9.9481C17.2217 10.0454 18.3065 9.8403 19.2754 9.35583C20.2444 8.87135 21.0593 8.12663 21.6288 7.2051C22.1983 6.28357 22.5 5.22165 22.5 4.13833C22.5 2.99667 22.33 1.85667 21.92 0.816667C28.55 3.01667 33.3333 9.26833 33.3333 16.6383C33.3333 25.8433 25.8717 33.305 16.6667 33.305C7.46167 33.305 0 25.8433 0 16.6383C0 7.76333 6.93667 0.51 15.6833 0ZM21.0667 22.025C20.7271 21.7422 20.2892 21.6059 19.8492 21.6459C19.4091 21.6859 19.003 21.899 18.72 22.2383C18.1217 22.955 17.39 23.305 16.6667 23.305C15.9433 23.305 15.2117 22.955 14.6133 22.2383C14.3268 21.9109 13.9237 21.7084 13.4899 21.6742C13.0561 21.64 12.6262 21.7768 12.292 22.0554C11.9577 22.3339 11.7456 22.7321 11.701 23.1649C11.6565 23.5977 11.7829 24.0308 12.0533 24.3717C13.1733 25.7167 14.7933 26.6383 16.6667 26.6383C18.54 26.6383 20.16 25.7167 21.28 24.3717C21.5628 24.0321 21.6991 23.5942 21.6591 23.1542C21.6191 22.7141 21.406 22.308 21.0667 22.025ZM10.8333 13.305C10.1703 13.305 9.53441 13.5684 9.06557 14.0372C8.59672 14.5061 8.33333 15.142 8.33333 15.805C8.33333 16.468 8.59672 17.1039 9.06557 17.5728C9.53441 18.0416 10.1703 18.305 10.8333 18.305C11.4964 18.305 12.1323 18.0416 12.6011 17.5728C13.0699 17.1039 13.3333 16.468 13.3333 15.805C13.3333 15.142 13.0699 14.5061 12.6011 14.0372C12.1323 13.5684 11.4964 13.305 10.8333 13.305ZM22.5 13.305C21.837 13.305 21.2011 13.5684 20.7322 14.0372C20.2634 14.5061 20 15.142 20 15.805C20 16.468 20.2634 17.1039 20.7322 17.5728C21.2011 18.0416 21.837 18.305 22.5 18.305C23.163 18.305 23.7989 18.0416 24.2678 17.5728C24.7366 17.1039 25 16.468 25 15.805C25 15.142 24.7366 14.5061 24.2678 14.0372C23.7989 13.5684 23.163 13.305 22.5 13.305Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Diamond: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8182 21.923L29.6364 8.02441H0L14.8182 21.923Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8164 21.923L9.87695 8.02441H19.7558L14.8164 21.923Z"
        fill={iconColor}
      />
      <path
        d="M4.93941 0L0 8.02435H29.6364L24.697 0H4.93941Z"
        fill={iconColor}
      />
      <path
        d="M4.93941 2.20912e-05L9.87881 8.02437H0L4.93941 2.20912e-05Z"
        fill={iconColor}
      />
      <path
        d="M14.8164 0L19.7558 8.02435H9.87695L14.8164 0Z"
        fill={iconColor}
      />
      <path
        d="M24.6972 2.20912e-05L29.6366 8.02437H19.7578L24.6972 2.20912e-05Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const DollarSign: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3405 7.12005L12.6221 8.03903C12.4364 7.49606 12.1753 6.98305 11.8469 6.51567C11.5242 6.15688 11.1371 5.86458 10.7064 5.65464V10.175C13.8126 11.0223 15.8878 11.915 16.9322 12.8533C17.6014 13.4506 18.1334 14.1908 18.4904 15.0215C18.8475 15.8521 19.0208 16.7527 18.998 17.6594C19.0117 18.7459 18.7592 19.8188 18.2634 20.7806C17.7928 21.6956 17.1469 22.505 16.364 23.1609C15.6339 23.7743 14.7986 24.2445 13.9005 24.5476C12.8652 24.8593 11.7938 25.0291 10.7145 25.0526V28H8.48235V25.0526C7.23808 24.9738 6.00968 24.726 4.82966 24.3158C3.93091 23.9847 3.10386 23.4786 2.39454 22.8255C1.75171 22.2455 1.21567 21.553 0.811708 20.7806C0.416628 19.9409 0.143205 19.047 0 18.1271L6.18521 17.3944C6.28304 18.1802 6.53864 18.9369 6.93604 19.6174C7.34054 20.149 7.87138 20.5664 8.47829 20.8303V15.2957C6.96673 14.9154 5.48848 14.4086 4.05854 13.7806C3.06856 13.2651 2.24222 12.4738 1.67542 11.4986C1.10862 10.5233 0.824611 9.4041 0.856352 8.27085C0.83745 7.40134 0.997844 6.53748 1.32714 5.73524C1.65644 4.93299 2.1473 4.21025 2.76792 3.61384C4.04501 2.36369 5.93899 1.67376 8.44988 1.54406V0H10.6821V1.53578C12.9765 1.67928 14.7352 2.23122 15.9582 3.1916C17.1871 4.16856 18.0323 5.56222 18.3405 7.12005ZM8.47423 5.57185C7.9505 5.71263 7.47552 5.99929 7.10244 6.39976C6.83809 6.71916 6.69418 7.1243 6.69659 7.54228C6.69167 7.9745 6.83526 8.39482 7.10244 8.73034C7.46847 9.14167 7.9413 9.43878 8.46611 9.58723V5.57185H8.47423ZM10.7064 20.9834C11.4244 20.8628 12.0888 20.5204 12.6099 20.0024C12.9973 19.5916 13.2152 19.0448 13.2187 18.4749C13.2129 17.9732 13.0316 17.4902 12.7073 17.113C12.1435 16.568 11.456 16.174 10.7064 15.9663V20.9834Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const FiveStar: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0021 1.25947C16.8171 -0.419823 19.1829 -0.419821 19.9979 1.25947L23.8301 9.15552C24.1534 9.82181 24.7805 10.2841 25.5064 10.3913L34.0934 11.6602C35.9156 11.9295 36.6449 14.1938 35.3293 15.4979L29.1018 21.6708C28.5803 22.1877 28.3424 22.9306 28.4653 23.6587L29.9335 32.3637C30.2441 34.2052 28.3319 35.6068 26.6996 34.7341L19.0398 30.6391C18.3892 30.2913 17.6108 30.2913 16.9602 30.6391L9.3004 34.7341C7.66811 35.6068 5.75595 34.2052 6.06653 32.3637L7.53475 23.6587C7.65756 22.9306 7.41971 22.1877 6.89822 21.6708L0.670684 15.4979C-0.644888 14.1938 0.0843737 11.9295 1.90664 11.6602L10.4936 10.3913C11.2195 10.2841 11.8466 9.82181 12.1699 9.15552L16.0021 1.25947Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Flower: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0C10.9487 0 9.28572 1.62297 9.28572 3.625V3.69007L9.22798 3.65753C7.45147 2.65652 5.17984 3.25056 4.15417 4.98438C3.1285 6.71819 3.73718 8.9352 5.51369 9.93622L5.57143 9.96875L5.5137 10.0013C3.73718 11.0023 3.1285 13.2193 4.15417 14.9531C5.17985 16.6869 7.45147 17.281 9.22798 16.28L9.28572 16.2474V16.3125C9.28572 18.3145 10.9487 19.9375 13 19.9375C15.0513 19.9375 16.7143 18.3145 16.7143 16.3125V16.2474L16.772 16.28C18.5485 17.281 20.8202 16.6869 21.8458 14.9531C22.8715 13.2193 22.2628 11.0023 20.4863 10.0013L20.4286 9.96875L20.4863 9.93622C22.2628 8.9352 22.8715 6.71819 21.8458 4.98438C20.8202 3.25056 18.5485 2.65652 16.772 3.65753L16.7143 3.69007V3.625C16.7143 1.62297 15.0513 0 13 0ZM12.9999 12.6875C14.5384 12.6875 15.7856 11.4703 15.7856 9.96875C15.7856 8.46723 14.5384 7.25 12.9999 7.25C11.4614 7.25 10.2142 8.46723 10.2142 9.96875C10.2142 11.4703 11.4614 12.6875 12.9999 12.6875Z"
        fill={iconColor}
      />
      <path
        d="M11.1429 29H9.28571C4.15736 29 0 24.9426 0 19.9375V18.125H1.85714C6.9855 18.125 11.1429 22.1824 11.1429 27.1875V29Z"
        fill={iconColor}
      />
      <path
        d="M16.7143 29H14.8571V27.1875C14.8571 22.1824 19.0145 18.125 24.1429 18.125H26V19.9375C26 24.9426 21.8426 29 16.7143 29Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const FourStar: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3591 0.848824C12.9395 -0.282942 14.5498 -0.282941 15.1303 0.848825L18.8182 8.03922C18.9667 8.32883 19.2014 8.56469 19.4896 8.71396L26.6447 12.4201C27.7709 13.0034 27.7709 14.6216 26.6447 15.2049L19.4896 18.911C19.2014 19.0603 18.9667 19.2962 18.8182 19.5858L15.1303 26.7762C14.5498 27.9079 12.9395 27.9079 12.3591 26.7762L8.67118 19.5858C8.52264 19.2962 8.28793 19.0603 7.99974 18.911L0.844656 15.2049C-0.281553 14.6216 -0.281551 13.0034 0.844657 12.4201L7.99974 8.71396C8.28793 8.56469 8.52264 8.32883 8.67118 8.03921L12.3591 0.848824Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Group: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 0C16.844 -9.77446e-09 16.1945 0.129199 15.5885 0.380222C14.9825 0.631244 14.4318 0.999173 13.968 1.463C13.5042 1.92683 13.1362 2.47747 12.8852 3.0835C12.6342 3.68952 12.505 4.33905 12.505 4.995C12.505 5.65095 12.6342 6.30048 12.8852 6.9065C13.1362 7.51253 13.5042 8.06317 13.968 8.527C14.4318 8.99083 14.9825 9.35876 15.5885 9.60978C16.1945 9.8608 16.844 9.99 17.5 9.99C18.8248 9.99 20.0953 9.46374 21.032 8.527C21.9687 7.59025 22.495 6.31976 22.495 4.995C22.495 3.67024 21.9687 2.39975 21.032 1.463C20.0953 0.526257 18.8248 0 17.5 0ZM28.75 2.495C27.7554 2.495 26.8016 2.89009 26.0983 3.59335C25.3951 4.29661 25 5.25044 25 6.245C25 7.23956 25.3951 8.19339 26.0983 8.89665C26.8016 9.59991 27.7554 9.995 28.75 9.995C29.7446 9.995 30.6984 9.59991 31.4017 8.89665C32.1049 8.19339 32.5 7.23956 32.5 6.245C32.5 5.25044 32.1049 4.29661 31.4017 3.59335C30.6984 2.89009 29.7446 2.495 28.75 2.495ZM6.25 2.495C5.25544 2.495 4.30161 2.89009 3.59835 3.59335C2.89509 4.29661 2.5 5.25044 2.5 6.245C2.5 7.23956 2.89509 8.19339 3.59835 8.89665C4.30161 9.59991 5.25544 9.995 6.25 9.995C7.24456 9.995 8.19839 9.59991 8.90165 8.89665C9.60491 8.19339 10 7.23956 10 6.245C10 5.25044 9.60491 4.29661 8.90165 3.59335C8.19839 2.89009 7.24456 2.495 6.25 2.495ZM10 14.9775C10.0046 14.3175 10.2701 13.6861 10.7384 13.221C11.2067 12.756 11.84 12.495 12.5 12.495H22.5C23.163 12.495 23.7989 12.7584 24.2678 13.2272C24.7366 13.6961 25 14.332 25 14.995V22.495C25.0007 23.2819 24.8775 24.0639 24.635 24.8125C24.0814 26.5093 22.9411 27.9531 21.4188 28.8847C19.8965 29.8164 18.0919 30.1748 16.3291 29.8957C14.5663 29.6165 12.9607 28.7181 11.8007 27.3617C10.6407 26.0053 10.0023 24.2798 10 22.495V14.9775ZM7.5 14.995C7.5 14.0825 7.7425 13.23 8.17 12.495H2.5C1.83696 12.495 1.20107 12.7584 0.732233 13.2272C0.263392 13.6961 3.46033e-07 14.332 3.46033e-07 14.995V21.245C-0.000340119 22.2683 0.250565 23.276 0.730682 24.1796C1.2108 25.0832 1.90544 25.8552 2.75361 26.4276C3.60177 27 4.57751 27.3555 5.59514 27.4627C6.61277 27.5699 7.64116 27.4256 8.59 27.0425C7.87198 25.6334 7.49843 24.074 7.5 22.4925V14.995ZM27.5 14.995V22.495C27.5 24.1325 27.1075 25.6775 26.41 27.0425C27.3588 27.4256 28.3872 27.5699 29.4049 27.4627C30.4225 27.3555 31.3982 27 32.2464 26.4276C33.0946 25.8552 33.7892 25.0832 34.2693 24.1796C34.7494 23.276 35.0003 22.2683 35 21.245V14.995C35 14.332 34.7366 13.6961 34.2678 13.2272C33.7989 12.7584 33.163 12.495 32.5 12.495H26.83C27.255 13.23 27.5 14.0825 27.5 14.995Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Heart: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 9.75371C0 17.8587 6.7 22.177 11.6033 26.0437C13.3333 27.407 15 28.692 16.6667 28.692C18.3333 28.692 20 27.4087 21.73 26.042C26.635 22.1787 33.3333 17.8587 33.3333 9.75537C33.3333 1.65204 24.1667 -4.09962 16.6667 3.69371C9.16667 -4.09962 0 1.64871 0 9.75371Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Hexagon: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="-1.75 -0.5 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5574 0L25.1147 7.25V21.75L12.5574 29L0 21.75V7.25L12.5574 0Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Home: React.FC<IconProps> = ({ size = 16, color = "#808080" }) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.3333 13.3333L16.6667 0L0 13.3333V16.6667H3.33333V33.3333H11.6667V26.6667C11.6667 25.3406 12.1934 24.0688 13.1311 23.1311C14.0688 22.1934 15.3406 21.6667 16.6667 21.6667C17.9927 21.6667 19.2645 22.1934 20.2022 23.1311C21.1399 24.0688 21.6667 25.3406 21.6667 26.6667V33.3333H30V16.6667H33.3333V13.3333Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Pencil: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.682 0.374164C17.4092 0.119616 17.0953 -0.0170173 16.744 0.00169955C16.3927 0.00169955 16.0788 0.138332 15.8247 0.41347L13.7526 2.56778L19.5579 8.18844L21.6487 5.99483C21.9028 5.74028 22 5.40712 22 5.05524C22 4.70337 21.8636 4.37021 21.6095 4.13437L17.682 0.374164ZM7.74545 20.5097C6.98311 20.7643 6.20209 21.0001 5.43789 21.2547C4.67556 21.5092 3.91322 21.7638 3.13033 22.0183C1.31231 22.606 0.314549 22.9392 0.0996753 22.9972C-0.115199 23.0552 0.0211996 22.2148 0.471501 20.4517L1.9177 14.9096L2.03728 14.7861L7.74732 20.506L7.74545 20.5097ZM4.15052 12.5869L12.1831 4.19801L17.9884 9.79809L9.85869 18.3049L4.15052 12.5869Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const Plant: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5_5)">
        <path
          d="M27.4894 3.94643C27.4894 9.10653 24.2044 13.4956 19.6214 15.1169C18.397 15.5501 17.08 15.7857 15.7082 15.7857V23.6786H23.5623V27.625H3.92705V23.6786H11.7812V19.7321C5.2746 19.7321 0 14.4315 0 7.89286V3.94643H3.92705C7.31836 3.94643 10.375 5.38642 12.5245 7.69117C13.6263 8.87251 14.4898 10.281 15.0378 11.8393H15.7082C16.8618 11.8393 17.9573 11.5893 18.9441 11.1404C18.1182 8.44085 16.5913 6.0498 14.5769 4.18179C16.7379 1.62347 19.9614 0 23.5623 0H27.4894V3.94643Z"
          fill={iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_5">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Tools: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_2)">
        <path
          d="M32.8513 30.4833L30.4847 32.85C30.1724 33.1604 29.75 33.3347 29.3097 33.3347C28.8693 33.3347 28.4469 33.1604 28.1347 32.85L8.33465 13.0833C7.79272 13.2405 7.2322 13.3246 6.66799 13.3333C5.60683 13.3326 4.56118 13.0785 3.61797 12.5923C2.67477 12.106 1.86126 11.4017 1.24509 10.5377C0.62892 9.67377 0.227886 8.67522 0.0753319 7.62508C-0.0772226 6.57494 0.02311 5.50356 0.367988 4.5L4.60132 8.73333L5.48465 7.85L7.85132 5.48333L8.73465 4.6L4.50132 0.366667C5.50488 0.0217888 6.57626 -0.0785438 7.6264 0.0740107C8.67654 0.226565 9.67509 0.627599 10.539 1.24377C11.403 1.85994 12.1074 2.67345 12.5936 3.61665C13.0798 4.55985 13.3339 5.6055 13.3347 6.66667C13.3259 7.23088 13.2419 7.7914 13.0847 8.33333L32.8513 28.1333C33.1617 28.4456 33.336 28.868 33.336 29.3083C33.336 29.7486 33.1617 30.1711 32.8513 30.4833ZM0.484655 28.1333C0.174236 28.4456 0 28.868 0 29.3083C0 29.7486 0.174236 30.1711 0.484655 30.4833L2.85132 32.85C3.16359 33.1604 3.58601 33.3347 4.02632 33.3347C4.46663 33.3347 4.88905 33.1604 5.20132 32.85L14.318 23.75L9.60132 19.0333M30.0013 0L23.3347 3.33333V6.66667L19.718 10.2833L23.0513 13.6167L26.668 10H30.0013L33.3347 3.33333L30.0013 0Z"
          fill={iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_4_2">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Wings: React.FC<IconProps> = ({
  size = 16,
  color = "#808080",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size * 1.4}
      height={size * 0.7}
      viewBox="0 0 60 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6586 28C26.4455 25.7593 27.3178 23.5531 27.4048 21.3815C27.5877 16.8309 24.9776 13.4352 21.1004 10.9893C17.0224 8.4166 12.8285 7.77803 8.75047 5.86004C6.71371 4.90334 4.28432 3.33575 0.242027 0C-1.07863 3.61699 3.12428 9.42862 9.95067 12.5016C7.83583 12.5869 5.55813 11.916 3.06851 10.2562C3.23805 14.853 6.74048 17.6815 14.5127 18.7742C12.8775 19.339 10.9233 19.369 8.42923 18.6405C10.8319 26.928 20.7435 20.9919 24.6586 28Z"
        fill={iconColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.3414 28C33.5545 25.7593 32.6822 23.5531 32.5952 21.3815C32.4123 16.8309 35.0224 13.4352 38.8996 10.9893C42.9776 8.4166 47.1715 7.77803 51.2495 5.86004C53.2863 4.90334 55.7157 3.33575 59.758 0C61.0786 3.61699 56.8757 9.42862 50.0493 12.5016C52.1642 12.5869 54.4419 11.916 56.9315 10.2562C56.7619 14.853 53.2595 17.6815 45.4873 18.7742C47.1225 19.339 49.0767 19.369 51.5708 18.6405C49.1681 26.928 39.2565 20.9919 35.3414 28Z"
        fill={iconColor}
      />
    </svg>
  );
};
